import React from 'react';
import { browserHistory } from 'react-router';
import axios from 'axios';

import Form from '../../../../../../components/Form/Form/';
import Spinner from '../../../../../../components/Spinner';

import './Signin.scss';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValues: {},
      error: null,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
  }

  handleChange(event) {
    this.setState({
      currentValues: event.target.value,
      error: null,
    });
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 13: // Enter
        event.preventDefault();
        this.handleAuthentication();
        break;
    }
  }

  handleAuthentication() {
    const FormData = this.state.currentValues;
    const validateInput = (form, input) => !(Object.prototype.hasOwnProperty.call(form, input) && form[input] !== '');

    if (validateInput(FormData, 'email')) {
      this.setState({
        error: 'Please enter your email',
      });
      return;
    }

    if (validateInput(FormData, 'password')) {
      this.setState({
        error: 'Please enter your password',
      });
      return;
    }

    this.setState({
      loading: true,
    });

    axios.post(__AuthLink, { // eslint-disable-line no-undef
      email: FormData.email,
      password: FormData.password,
    }).then(response => {
      this.props.authenticateUser(response.data.token);
      this.setState({
        loading: false,
      });
    }).catch(err => {
      console.log('Error: ', err);
      this.setState({
        error: err.response.data.error,
        loading: false,
      });
    });
  }

  componentDidMount() { // Redirect on initial render if autehnticated
    if (this.props.authenticatedID !== null) {
      browserHistory.push('/company/home');
    }
  }

  componentWillReceiveProps(nextProps) { // If the user logins in redirect them
    if (nextProps.authenticatedID !== null) {
      browserHistory.push('/company/home');
    }
  }

  render() {
    return (
      <div className='SignIn__Wrapper'>
        <Form>
          <h2 className='FormSegment__title'>Sign into your account</h2>
          {(this.state.error !== null) ? <p className='errorText'>{this.state.error}</p> : null}
          <Form onChange={this.handleChange}>
            <div className='row'>
              <div className='col-md'>
                <input type='text' placeholder='Email' onKeyDown={this.handleOnKey} className='Form__Input' name='email' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md'>
                <input type='password' placeholder='Password' onKeyDown={this.handleOnKey} className='Form__Input' name='password' />
              </div>
            </div>
          </Form>
          <span onClick={this.handleAuthentication} className='Button__Submit'>
            {(this.state.loading) ? <Spinner className='spinner--white' /> : 'Login'}
          </span>
        </Form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/company/routes/Login/components/Login/index.js